import dynamic from "@redux-dynostore/react-redux";
import React from "react";
import { connect } from "react-redux";

import FoodDrinkSelector from "../../../library/LCF401/FoodDrinkSelector/FoodDrinkSelector";

import { mapDispatchToProps } from "./FoodDrinkSelector.store";

export const SmartFoodDrinkSelector = (props) => {
  const {
    defaultItems,
    selectedItems,
    setSelectedItems,
    fetchFoodAPI,
    fetchFoodDetailsAPI,
    readOnly,
    inputTitle,
    participantLanguage,
    title = "My items",
  } = props;

  return (
    <FoodDrinkSelector
      defaultItems={defaultItems}
      handleSearch={(query) => fetchFoodAPI(query, participantLanguage)}
      handleSelect={(item, type, locale) =>
        fetchFoodDetailsAPI(item, type, locale)
      }
      selectedItems={selectedItems}
      setSelectedItems={setSelectedItems}
      readOnly={readOnly}
      inputTitle={inputTitle}
      title={title}
    />
  );
};

export default dynamic("smartPageHeaderReducer")(
  connect(null, mapDispatchToProps)(SmartFoodDrinkSelector)
);
